export enum WellevateLoyalistMigrationEntryPoint {
  NEW_TO_FULLSCRIPT = "New to Fullscript",
  HAS_EXISTING_FULLSCRIPT_ACCOUNT = "Has existing Fullscript Account",
}

type UnauthEntryPoint = WellevateLoyalistMigrationEntryPoint;

export type { UnauthEntryPoint };
